export default __webpack_public_path__ + "static/herorichardquinn-376fb4f6a2646f82bf726ba5a58a3212.jpg";